<mat-card>
    <mat-card-title>404 Not Found</mat-card-title>
    <mat-card-content>We couldn't find the page you're looking for...</mat-card-content>

</mat-card>